module.exports = __webpack_public_path__ + "barcelonababysitter.png?440b4c89259364bfbfc6f83d0e51576b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/customer_logos/barcelonababysitter.png
// module id = 107
// module chunks = 0